import styled from 'styled-components';

export const MainTitle = styled.div`
  font-size: 2.5rem;
  font-weight: bold;
  margin: 0.5em;
`;

// Containers
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  background: white;
  height: auto;
  width: auto;
  flex-wrap: nowrap;
  border-radius: 5px;
  box-shadow: '0px 0px 6px #E3E3E3';
  min-height: 170px;
  padding-top: 1em;
  padding-bottom: 1em;
`;

export const WorkLocation = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const FormTitle = styled.div`
  margin-left: 1.5em;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const FormTitleItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font: normal normal 600 24px/26px Biotif;
  margin: 21px 0px;
`;

export const EditIcon = styled.img`
  width: 15px;
  margin-left: 2rem;
`;

export const FormRow = styled.div`
  display: flex;
`;

export const WorkLocationFormContainer = styled.div`
  display: flex;
  margin-left: 1.5em;
  flex-wrap: wrap;
`;

export const FormInputContainer = styled.div`
  display: flex;
  width: calc(50% - 10px);
  flex-direction: column;
`;

export const SeparatorLineStraight = styled.div`
  min-height: 1.5px;
  background-color: #9399b247;
  margin-bottom: 20px;
`;

export const FormInputLabel = styled.label`
  margin-top: 7px;
  font:
    normal normal normal 16px Biotif,
    Medium;
  color: #707070;
  flex: 0 0 40%;
`;
